import { FC } from "react";

import CloseIcon from "@mui/icons-material/Close";
import {
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography,
} from "@mui/material";

import { Translate } from "@/components/Application/Translate";
import NewWizardChecklistForm from "@/components/Procedures/NewChecklist/NewWizardChecklistForm";

import { ProcedureDetailNode } from "@/model/Procedure/ProcedureDetailNode";

interface NewChecklistModalProps {
	open: boolean;
	onClose: () => void;
	selectedNode?: ProcedureDetailNode;
}

const NewChecklistModal: FC<NewChecklistModalProps> = ({
	open,
	onClose,
	selectedNode,
}) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{ fontSize: "1.25rem", fontWeight: 500 }}>
				<Translate String="Procedure.Checklist.New">New Checklist</Translate>
				<Typography
					variant="subtitle2"
					sx={{
						fontSize: "0.8rem",
						fontWeight: 400,
						color: (theme) => theme.palette.text.secondary,
						marginTop: "0.5rem",
					}}
				>
					{selectedNode?.Name}
				</Typography>
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
					}}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<br />
			<DialogContent sx={{ p: 2 }} dividers>
				<NewWizardChecklistForm onClose={onClose} node={selectedNode} />
			</DialogContent>
		</Dialog>
	);
};

export default NewChecklistModal;
